<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" epub:type="prologue" id="prologue" role="doc-prologue">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-upper">PROLOGUE</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width">Few things made Dean Stillbrook happy any more but the one part of the day he really enjoyed, relished, adored, was his early morning walk through the woods from his flat to work.</p>
<p class="subsq">The hideous experience of the last six months was only now starting to blur into the past where it belonged. He hadn’t for one moment believed that he would ever look forward to the rest of his life. One stupid mistake had cost him so much but he was learning to adapt and be glad for the small things in his day-to-day existence.</p>
<p class="subsq">As he made his way deeper into the trees, he paused for a second to tilt his face up towards the sky, the May sunshine breaking through the branches and warming his face. He stood still, eyes shut, and listened to the birds, a slight breeze rustling the leaves, and then he heard the sound of movement behind him.</p>
<p class="subsq">It happened with such speed, Dean couldn’t have reacted if he had wanted to.</p>
<p class="subsq">His brain was finding it difficult to comprehend that such a beautiful bright sunny morning that seemed to hold such promise could possibly result in someone tightening a noose around his neck, the rope tearing into his flesh as it pulled him straight up towards the sky he had only moments before stopped to admire.</p>
<p class="subsq">‘Please,’ he tried to say, but the noose was already eating into his skin and cutting off the last breath he would take. He didn’t even have time for his fingertips to attempt the futile gesture of prising themselves between the rope and his throat; let alone for the questions that would have surged through his mind before he blacked out, the most pressing of all being ‘Why?’</p>
<p class="subsq">Even though Dean Stillbrook was long past caring or knowing, it was more merciful that he couldn’t feel the pain of the rope cutting into him as he was lifted up towards an overhanging branch.</p>
<p class="subsq">He wasn’t able to hear the grunts and moans of his executioner as he pulled him higher off the ground, feet left dangling in the air.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?5212a796